import { Badge } from "reactstrap";
import { formatCnpj } from "utils";

export const CustomSimpleStore = ({ data }) => (
  <>
    <div className="d-flex align-items-center justify-content-between">
      <small className="fw-bolder fs-6">
        {data?.company?.companyName ??
          data?.company?.company_name ??
          data?.companyName}
      </small>
      <Badge color="warning">{data?.state}</Badge>
    </div>

    {data?.cnpj && (
      <Badge style={{ marginTop: "4px" }} pill color="primary">
        CNPJ: {formatCnpj(data?.cnpj)}
      </Badge>
    )}
  </>
);
